export const charLimit = (char, limit) => {
  char?.length > limit ? (
    <>
      {char?.slice(limit)}...<button>Read more</button>
    </>
  ) : (
    <>{char}</>
  );
};

export const bloodGroups = [
  {
    label: "A+",
    value: "A+",
  },
  {
    label: "B+",
    value: "B+",
  },
  {
    label: "A-",
    value: "A-",
  },
  {
    label: "B-",
    value: "B-",
  },
  {
    label: "AB+",
    value: "AB+",
  },
  {
    label: "AB-",
    value: "AB-",
  },
  {
    label: "O+",
    value: "O+",
  },
  {
    label: "O-",
    value: "O-",
  },
]
